<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <button-export
        :href="exportUrl"
        download="download.xls"
        value="导出"/>
      <div class="btn-box" style="display: flex;justify-content: center">
        <input-select selectTitle="报警类型" :selectKey="'alarmType'" :selectData="alarmTypeList" @search="search" style="margin-right: 10px;"/>
        <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <input-search placeholder="设备名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" @lookOver="lookOver" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />

    <el-dialog
      :visible.sync="dialogVisible"
      width="40%">
      <img :src="lookOverImg" alt="" style="width: 90%;margin: 0 auto;">
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../components/Button/ButtonAdd'
  import ButtonDelete from '../../components/Button/ButtonDelete'
  import ButtonExport from '../../components/common/buttons/button-export'
  import ButtonUpload from '../../components/common/buttons/button-upload'
  import InputSearch from '../../components/Input/InputSearch'
  import InputSelect from '../../components/Input/InputSelect'
  import TableMain from '../../components/Table/TableMain'
  import {api} from '../api/yqingService'
  import {errorHandler} from '../../utils/errorHandler'
  import {nAlert, nSuccess} from '../../utils/notice'
  import {bus} from '../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'call-police',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '报警服务',
          name: 'yqing-device-management'
        }, {
          value: '报警记录'
        }],
        addController: 'controller-add',
        exportUrl: '',
        timevalue: [],
        pickerOptions2: {
          disabledDate (time) {
            return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        alarmTypeList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '1',
            label: '防拆报警'
          }, {
            key: '2',
            label: '越栏报警'
          }, {
            key: '3',
            label: '安全帽报警'
          }, {
            key: '4',
            label: '无权限车报警'
          }, {
            key: '5',
            label: '人员闯入报警'
          }
        ],
        tableHead: [{
          prop: 'deviceName',
          label: '设备名称'
        }, {
          prop: 'rentName',
          label: '站点名称'
        }, {
          prop: 'alarmTypeText',
          label: '报警类型'
        }, {
          prop: 'alarmTime',
          label: '报警时间'
        }, {
          prop: 'responsiblePersonName',
          label: '责任人'
        }, {
          prop: 'yqPicUrl',
          label: '抓拍图片',
          isLookOver: true
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          startTime: '',
          endTime: '',
          searchKey: '',
          alarmType: ''
        },
        lookOverImg: '',
        dialogVisible: false
      }
    },
    created () {
      // this.permissionCodes = bus.global.permissionCodes
      this.exportUrl = `${api.exportyqingAlarmRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy`
      this.getCreateTime()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportyqingAlarmRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`
      },
      getCreateTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate()
        let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
        let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
        let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
        this.timevalue[0] = year + '-' + month + '-01' + ' ' + '00:00:00'
        this.timevalue[1] = year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
        this.getPage()
      },
      // 获取报警记录
      getPage () {
        if (this.timevalue) {
          this.requestData.startTime = this.timevalue[0]
          this.requestData.endTime = this.timevalue[1]
        } else {
          this.requestData.startTime = ''
          this.requestData.endTime = ''
        }
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize

        this.$axios.post(api.getYqingAlarmRecord, reqData)
          .then(res => {
            let data = res.data.data.list
            data.map(v => {
              if (v.alarmType === '1') {
                v.alarmTypeText = '防拆报警'
              } else if (v.alarmType === '2') {
                v.alarmTypeText = '越栏报警'
              } else if (v.alarmType === '3') {
                v.alarmTypeText = '安全帽报警'
              } else if (v.alarmType === '4') {
                v.alarmTypeText = '无权限车报警'
              } else if (v.alarmType === '5') {
                v.alarmTypeText = '人员闯入报警'
              } else {
                v.alarmTypeText = '--'
              }
              v.yqPicUrl = v.picUrl
            })
            this.total = res.data.data.total
            this.tableData = data
          })
          .catch(errorHandler('获取报警记录失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      lookOver (imgUrl) {
        this.lookOverImg = imgUrl
        this.dialogVisible = true
      }
    },
    watch: {
      timevalue (val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/CallPolice/CallPolice.vue